import { Link } from "react-router-dom";
import type { DashboardOverview } from "@/types/dashboard";
import { formatDate, inspectionTypeText, workflowText, workflowTone } from "../labels";

const TONE = {
  ok: "bg-primary-50 text-primary-700",
  wait: "bg-warning-50 text-warning-700",
  bad: "bg-danger-50 text-danger-700",
  idle: "bg-background-100 text-foreground-600",
} as const;

export default function RecentInspections({ items }: { items: DashboardOverview["recentInspections"] }) {
  return (
    <section className="bg-white rounded-card border border-background-200 p-5 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-base font-semibold text-foreground-900 font-heading">Vistorias recentes</h3>
          <p className="text-xs text-foreground-500 mt-0.5">As 8 mais recentes da organização</p>
        </div>
        <Link to="/vistorias" className="text-xs font-medium text-primary-700 hover:text-primary-800">
          Ver todas
        </Link>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-foreground-500 py-8 text-center">Nenhuma vistoria registrada ainda.</p>
      ) : (
        <div className="overflow-x-auto -mx-1">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs text-foreground-500">
                <th className="px-1 py-2 font-medium">Exemplar</th>
                <th className="px-1 py-2 font-medium hidden sm:table-cell">Tipo</th>
                <th className="px-1 py-2 font-medium">Situação</th>
                <th className="px-1 py-2 font-medium text-right">Data</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-background-100">
              {items.map((i) => (
                <tr key={i.id} className="hover:bg-background-50">
                  <td className="px-1 py-2.5">
                    <Link to={`/cta/${i.treeId}/inspecoes/${i.id}`} className="font-medium text-foreground-900 hover:text-primary-700">
                      {i.treeCode}
                    </Link>
                    <p className="text-xs text-foreground-500">{i.speciesName ?? "Espécie não identificada"}</p>
                  </td>
                  <td className="px-1 py-2.5 text-foreground-600 hidden sm:table-cell">{inspectionTypeText(i.inspectionType)}</td>
                  <td className="px-1 py-2.5">
                    <span className={`text-[11px] font-semibold rounded-full px-2 py-0.5 ${TONE[workflowTone(i.workflowStatus)]}`}>
                      {workflowText(i.workflowStatus)}
                    </span>
                  </td>
                  <td className="px-1 py-2.5 text-right text-foreground-600 tabular-nums">{formatDate(i.inspectionDate)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
